export default "__VITE_ASSET__D8QLg9sT__"